import FetchWrapper from '../Common/Wrappers/FetchWrapper';
import { Service } from '../Common/service.enum';
import Logging from '../../Logging/Logging';
import {
  SettingsCollection,
  Setting,
  TaxPayerCollection,
  TaxPayer,
} from '../../..';
import { filtersToStandardQueryParams, sortModelToStandardQueryParam } from '../Common/filterSorting';

export default class SettingsRepo {
  private fetch: FetchWrapper;

  constructor(fetch: FetchWrapper) {
    this.fetch = fetch;
  }

  getCertificateSettingsV4(): Promise<SettingsCollection> {
    const apiServiceEndpoint = 'portal/v4/settings/certificates';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<SettingsCollection>(Service.ECM, url);
  }

  setCertificateSettingsV4(settings: Setting[]): Promise<void> {
    const apiServiceEndpoint = 'portal/v4/settings/certificates';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    const settingsCollection: SettingsCollection = {
      value: settings,
    };

    Logging.Info('PUT', url);
    return this.fetch.putToService<void>(Service.ECM, url, settingsCollection);
  }

  getCustomerSettingsV41(): Promise<SettingsCollection> {
    const apiServiceEndpoint = 'portal/v4.1/settings/customers';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<SettingsCollection>(Service.ECM, url);
  }

  setCustomerSettingsV41(settings: Setting[]): Promise<void> {
    const apiServiceEndpoint = 'portal/v4.1/settings/customers';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    const settingsCollection: SettingsCollection = {
      value: settings,
    };

    Logging.Info('PUT', url);
    return this.fetch.putToService<void>(Service.ECM, url, settingsCollection);
  }

  getECWizardSettingsV4(): Promise<SettingsCollection> {
    const apiServiceEndpoint = 'portal/v4.1/settings/wizard';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<SettingsCollection>(Service.ECM, url);
  }

  setECWizardSettingsV4(settings: Setting[]): Promise<void> {
    const apiServiceEndpoint = 'portal/v4.1/settings/wizard';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    const settingsCollection: SettingsCollection = {
      value: settings,
    };

    Logging.Info('PUT', url);
    return this.fetch.putToService<void>(Service.ECM, url, settingsCollection);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getTaxPayersV41(
    startRow: number,
    endRow: number,
    filterModel: string[] = null,
    sortModel: string[] = null,
  ): Promise<TaxPayerCollection> {
    const apiServiceEndpoint = 'portal/v4.1/taxpayers';
    const filterQueryParams = filtersToStandardQueryParams(filterModel);
    const sortQueryParam = sortModelToStandardQueryParam(sortModel);
    const numberRows = endRow > startRow ? endRow - startRow : 0;
    const pagingQueryParam = `&$top=${numberRows}&$skip=${startRow}&$count=true`;

    let queryParams = '';
    if (filterQueryParams && sortQueryParam) {
      queryParams = `?${filterQueryParams}&${sortQueryParam}`;
    } else if (filterQueryParams) {
      queryParams = `?${filterQueryParams}`;
    } else if (sortQueryParam) {
      queryParams = `?${sortQueryParam}`;
    }

    // Add the Paging Parameters
    if (pagingQueryParam) {
      queryParams += queryParams === '' ? `?${pagingQueryParam}` : pagingQueryParam;
    }

    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<TaxPayerCollection>(Service.ECM, url);
  }

  getTaxPayerV41(taxPayerUuid: string): Promise<TaxPayer> {
    const apiServiceEndpoint = `portal/v4.1/taxpayers/${taxPayerUuid}`;

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<TaxPayer>(Service.ECM, url);
  }

  addTaxPayerV41(taxPayer: TaxPayer): Promise<Headers> {
    const apiServiceEndpoint = 'portal/v4.1/taxpayers';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('POST', url, taxPayer);
    // Return the HTTP Headers instead of the Body.  The newly inserted Taxpayer Uuid will be in the 'Location' Header
    return this.fetch.postToServiceReturnHeaders<void>(Service.ECM, url, taxPayer);
  }

  editTaxPayerV41(taxPayer: TaxPayer): Promise<void> {
    const apiServiceEndpoint = `portal/v4.1/taxpayers/${taxPayer.uuid}`;

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('PUT', url, taxPayer);
    return this.fetch.putToService<void>(Service.ECM, url, taxPayer);
  }

  deleteTaxPayerV41(taxPayerUuid: string): Promise<void> {
    const apiServiceEndpoint = `portal/v4.1/taxpayers/${taxPayerUuid}`;

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('DELETE', url);
    return this.fetch.delFromService<void>(Service.ECM, url);
  }
}
